export default "<p>fixcat works!</p>\n";